import { getIconBaseProps } from './utils';

export const edit = {
  ...getIconBaseProps('edit'),
  width: '10px',
  height: '12px',
  viewBox: '0 0 10 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  body: (
    <>
      <path
        d='M0 10.9976H8.88728'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeLinejoin='round'
      />
      <path
        d='M3.57714 8.55072L0.827637 9.33669L1.6136 6.58718L6.91542 1.28537C7.29591 0.904878 7.90969 0.904878 8.29017 1.28537L8.87896 1.87415C9.25944 2.25463 9.25944 2.86841 8.87896 3.2489L3.57714 8.55072Z'
        strokeWidth='0.75'
        strokeLinejoin='round'
        stroke='currentColor'
      />
      <path
        d='M8.0958 4.03189L6.13226 2.06836'
        strokeWidth='0.75'
        strokeLinejoin='round'
        stroke='currentColor'
      />
    </>
  ),
};
